{
  "plovila": {
    "main": {
      "title": "Ispezioni CAMO - Aeromobili"
    },
    "buttons": {
      "nazaj": "Indietro",
      "nazajGlavni": "Menu principale"
    },
    "table": {
      "registracija": "Registrazione",
      "tip": "Tipo",
      "vrsta": "Categoria",
      "podrobno": "Dettagli",
      "s_ure": "Ore totali",
      "s_letov": "Voli totali"
    },
    "modal": {
      "vlecno": "Aeromobile trainante:",
      "obracun_servis": "Registrazione del volo:",
      "razpolozljivo": "Visibile nella disponibilità:",
      "tip": "Tipo:",
      "klub": "Club:",
      "stUr": "Numero iniziale di ore:",
      "stLetov": "Numero iniziale di voli:",
      "stSUr": "Ore di volo:",
      "vrsta": "Categoria dell'aeromobile:",
      "datumN": "Data di acquisto:",
      "datumR": "Data di registrazione:",
      "opombaJ": "Nota sull'aliante:",
      "datumV": "Data di inserimento:",
      "servis": {
        "stSUr": "Ore attuali:",
        "stLetov": "Voli attuali:",
        "interval": "Intervallo di manutenzione: ",
        "datum_zServis": "Data dell'ultima manutenzione: ",
        "opravljen_servis": "Manutenzione eseguita presso:",
        "naslednji_servis": "Prossima manutenzione: ",
        "status": "Stato: "
      }
    },
    "navs": {
      "vnos": "Inserimento",
      "seznam": "Elenco",
      "modal": {
        "pregled": "Panoramica",
        "servisna": "Registro di manutenzione"
      }
    }
  }
}
